import Api from "./Api";
import Csrf from "./Csrf";

export default {
  async show(area_permit_id) {
    await Csrf.getCookie();

    return Api.get("/external-permits/" + area_permit_id);
  },
  async store(permit_id) {
    await Csrf.getCookie();

    return Api.post("/external-permits/", { permit_id: permit_id });
  },

  async deleteFile(permit_id, file_id) {
    await Csrf.getCookie();

    return Api.delete("/external-permits/" + permit_id + "/files/" + file_id);
  },
};
